'use strict';

module.exports = thematicBreak;

/* Transform a thematic break / horizontal rule. */
function thematicBreak(h, node) {
  return h(node, 'hr');
}



//////////////////
// WEBPACK FOOTER
// ./~/remark-html/~/mdast-util-to-hast/lib/handlers/thematic-break.js
// module id = 101
// module chunks = 96961042003272 139266963665775